import React, { useState } from "react";
import { Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";

const ImportUsers = ({ onOpen, onClose, onSave }) => {
  const [file, setFile] = useState(null);

  const allowedTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const handleFileChange = (info) => {
    // Ant Design Upload returns 'file' or 'fileList' inside info
    const uploadedFile = info.file;
    
    if (allowedTypes.includes(uploadedFile.type) || uploadedFile.name.endsWith('.xlsx') || uploadedFile.name.endsWith('.xls')) {
      setFile(uploadedFile);
      message.success(`${uploadedFile.name} selected.`);
    } else {
      message.error("Invalid file type! Please upload an Excel file.");
    }
  };

  const handleSave = () => {
    if (!file) {
      message.error("Please upload a file before saving.");
      return;
    }
    // Agar parent mein onSave prop hai toh use call karein
    if (onSave) {
      onSave();
    } else {
      message.success("File imported successfully!");
     onClose();
    }
  };

  return (
    <DailogBox open={onOpen} onCancel={onClose} width="600px" footer={null}>
      <div className="p-4">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">Import Excel File</h3>
          <div className="w-full h-[1px] bg-gray-200 mt-4"></div>
        </div>

        {/* Download Template */}
        <div className="border rounded-xl mt-8 p-4 flex justify-between items-center bg-[#F5F7F6]">
          <span className="text-gray-600 font-medium">
            Click to download Employee list Format
          </span>
          <a
            href="/path-to-template.xlsx"
            download
            className="text-[#06513D] flex items-center font-bold hover:underline"
          >
            <UploadOutlined className="mr-2" /> Download Format
          </a>
        </div>

        {/* File Upload Area */}
        <div className="border-2 border-dashed border-gray-300 rounded-xl mt-6 p-6 flex flex-col items-center justify-center">
          <span className="text-gray-500 mb-4 text-center">
            {file ? (
              <strong className="text-[#06513D]">{file.name}</strong>
            ) : (
              "No file chosen. Please upload .xlsx or .xls file"
            )}
          </span>
          <Upload
            beforeUpload={() => false}
            showUploadList={false}
            onChange={handleFileChange}
          >
            <Button 
              icon={<UploadOutlined />} 
              className="bg-[#06513D] text-white h-10 rounded-lg hover:bg-[#043d2e] !border-none"
            >
              Browse File
            </Button>
          </Upload>
        </div>

        <div className="w-full h-[1px] bg-gray-200 mt-8"></div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-6 mt-8">
          <button
            onClick={onClose} // Typo 'onclose' fixed to 'onClose'
            className="w-32 h-11 rounded-xl border border-[#06513D] text-[#06513D] bg-white font-semibold hover:bg-gray-50 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="w-32 h-11 rounded-xl bg-[#06513D] text-white font-semibold shadow hover:bg-[#043d2e] transition-all"
          >
            Save
          </button>
        </div>
      </div>
    </DailogBox>
  );
};

export default ImportUsers;